import { ChartDataProps, ChartProductParams } from '../../types/chart'
import { DateFilterParams } from '../../types/dateFilter'
import { LinkClickParamsFP, PageVisitsParamsFP, ScansParamsFC } from '../../constants/charts'

export interface WelcomeToastData {
  scans: number
  linkClicks: number
  pageViews: number
  activeCodes: number
  activePages: number
}

export interface ConnectionDataType
  extends Omit<ChartDataProps, 'startDate' | 'endDate' | 'interval'>,
    ChartProductParams {}

export type GetConnectionReturnType = Record<
  'SCANS' | 'PAGE_VISITS' | 'LINK_CLICKS',
  ConnectionDataType
>

export const GetConnectionTypes: GetConnectionReturnType = {
  SCANS: ScansParamsFC,
  PAGE_VISITS: PageVisitsParamsFP,
  LINK_CLICKS: LinkClickParamsFP
}

export interface AnalyticsWelcomeToastProps {
  dateFilters: DateFilterParams
  welcomeToastData: WelcomeToastData
  displayDataCapToast?: boolean
}

export interface GetWelcomeToastDataProps {
  dateFilters: DateFilterParams
  dataTypes: ConnectionDataType[]
}

export interface UseWelcomeToastDataHelpers {
  getWelcomeToastData(props: GetWelcomeToastDataProps): Promise<WelcomeToastData>
}

export type AnalyticsWelcomeToastContentProps = {
  dateFilters: DateFilterParams
  displayDataCapToast?: boolean
} & WelcomeToastData
